import styled from 'styled-components';

// CONSTANTS
// import { BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const SStripePaymentFormWrapper = styled.div`
  .controls {
    margin-top: 30px;
    flex-direction: column-reverse;
    align-items: stretch;
    text-align: center;

    button[type='submit'] {
      margin-top: 0;
    }
  }

  button[type='submit'] {
    margin-top: 40px;
    width: 100%;
  }

  ${breakpoints.up('md')} {
    max-width: 350px;

    .controls {
      flex-direction: row;
      align-items: center;
    }

    button[type='submit'] {
      min-width: 200px;
    }
  }
`;

export default SStripePaymentFormWrapper;
